import React from 'react'

import Loading from 'components/base/Loading'

import { Props } from './types'

import {
  TextAreaWrap,
  TextAreaField,
  Error,
} from './styles'

const TextArea: React.FC<Props> = ({
  children,
  errorText,
  isErrored,
  loading,
  defaultValue,
  ...props
}): React.ReactElement => (loading && <Loading />) || (
  <TextAreaWrap>
    <TextAreaField {...props} isErrored={isErrored}>
      {children || defaultValue}
    </TextAreaField>
    {isErrored ? <Error>{errorText}</Error> : undefined}
  </TextAreaWrap>
)

export * from './types'

export default TextArea
